// import React from "react";
// import {
//   Home,
//   MapPin,
//   PhoneCall,
//   Navigation,
//   User,
//   DollarSign,
//   Calendar,
//   Trophy,
//   HelpCircle,
//   GraduationCap,
//   Lightbulb
// } from "lucide-react";
// import { useNavigate } from "react-router-dom";

// const VendorDashboard = () => {
//   const driverName = "Welcome, Anmol!";
//   const navigate = useNavigate();
//   return (
//     <div className="font-satoshi pt-[7rem] pl-4 pr-4 bg-gray-50 min-h-screen flex flex-col gap-6 mb-[5rem]">
//       {/* Header */}
//       <div className="flex items-center justify-between">
//         <div>
//           <h2 className="text-xl font-bold">{driverName}</h2>
//           <span className="text-sm text-gray-500">Level 76</span>
//         </div>

//       </div>

//       {/* Incoming Request */}
//       {/* <div className="bg-white p-4 rounded-xl shadow">
//         <h3 className="font-semibold text-gray-800 mb-2">Incoming Ride</h3>
//         <div className="text-sm text-gray-600 mb-1">Pickup: MG Road</div>
//         <div className="text-sm text-gray-600 mb-1">Drop: Airport</div>
//         <div className="text-sm text-gray-500 mb-2">ETA: 4 mins</div>
//         <button className="w-full bg-green-500 text-white py-2 rounded-lg font-semibold">
//           Accept Ride
//         </button>
//       </div> */}

//       {/* Earnings Summary */}
//       <div className="bg-white p-4 rounded-xl shadow flex justify-between items-center">
//         <div>
//           <div className="text-gray-600 text-sm">This Week</div>
//           <div className="font-bold text-xl">₹8,540</div>
//         </div>
//         <button className="bg-gray-100 px-4 py-2 rounded-lg text-sm font-semibold">
//           View Details
//         </button>
//       </div>

//       {/* Ongoing Trips */}
//       {/* <div className="bg-white p-4 rounded-xl shadow">
//         <h3 className="font-semibold mb-2">Ongoing Trip</h3>
//         <div className="flex justify-between items-center mb-2">
//           <div>
//             <div className="font-medium text-gray-800">Rider: John D.</div>
//             <div className="text-sm text-gray-500">From MG Road → Airport</div>
//           </div>
//           <div className="flex gap-2">
//             <button className="bg-blue-100 p-2 rounded-full">
//               <Navigation size={16} />
//             </button>
//             <button className="bg-green-100 p-2 rounded-full">
//               <PhoneCall size={16} />
//             </button>
//           </div>
//         </div>
//         <button className="w-full bg-red-500 text-white py-2 rounded-lg font-semibold">
//           End Trip
//         </button>
//       </div> */}

//       {/* Driver Tools */}
//       <div className="flex justify-between text-center">
//         <div className="flex flex-col items-center">
//           <GraduationCap className="text-orange-500" />
//           <span className="text-sm mt-1">Training</span>
//         </div>
//         <div className="flex flex-col items-center">
//           <HelpCircle className="text-blue-500" />
//           <span className="text-sm mt-1">Support</span>
//         </div>
//         <div className="flex flex-col items-center">
//           <Lightbulb className="text-yellow-500" />
//           <span className="text-sm mt-1">Tips</span>
//         </div>
//       </div>

//       {/* Performance Ranking */}
//       <div className="bg-white p-4 rounded-xl shadow">
//         <h3 className="font-semibold mb-2">Performance</h3>
//         <div className="flex gap-3 overflow-x-auto">
//           <div className="bg-yellow-100 px-4 py-2 rounded-xl text-center">
//             <Trophy className="mx-auto text-yellow-500" />
//             <div className="text-sm font-semibold">1st</div>
//             <div className="text-xs">Achiev. 2398</div>
//           </div>
//           <div className="bg-gray-100 px-4 py-2 rounded-xl text-center">
//             <User className="mx-auto text-gray-600" />
//             <div className="text-sm font-semibold">2nd</div>
//             <div className="text-xs">Customer 2019</div>
//           </div>
//           <div className="bg-gray-100 px-4 py-2 rounded-xl text-center">
//             <MapPin className="mx-auto text-gray-600" />
//             <div className="text-sm font-semibold">3rd</div>
//             <div className="text-xs">Nav. 1832</div>
//           </div>
//         </div>
//       </div>

//       {/* Bottom Nav */}
//       <div className="fixed bottom-0 left-0 right-0 bg-white border-t flex justify-around py-2 shadow-lg">
//         <button className="flex flex-col items-center text-blue-600">
//           <Home size={20} />
//           <span className="text-xs">Home</span>
//         </button>
//         <button className="flex flex-col items-center text-gray-500">
//           <Calendar size={20} />
//           <span className="text-xs">Trips</span>
//         </button>
//         <button className="flex flex-col items-center text-gray-500">
//           <DollarSign size={20} />
//           <span className="text-xs">Earnings</span>
//         </button>
//         <button onClick={()=>{navigate('/user-profile-section')}} className="flex flex-col items-center text-gray-500">
//           <User size={20} />
//           <span  className="text-xs">Profile</span>
//         </button>
//       </div>
//     </div>
//   );
// };

// export default VendorDashboard;


import React, { useEffect, useState } from "react";
import { ChevronRight, Menu, Bell, Calendar, CreditCard, Banknote, TrendingUp, X, AlertCircle, Info } from "lucide-react";
import axios from "../../../../axiosInstance.js";
import DashboardInformation from "./DashboardInformation";
import { useNavigate } from "react-router-dom";
import { TripOrigin } from "@mui/icons-material";

const VendorDashboard = () => {
  const [dashboardData, setDashboardData] = useState(null);
   const [paymentData, setPaymentData] = useState(null);
   const [showDatePicker, setShowDatePicker] = useState(false);
    const [selectedDateRange, setSelectedDateRange] = useState({
    from: "",
    to: ""
  });
  const [isLoading, setIsLoading] = useState(false);

  const [customDateSummary, setCustomDateSummary] = useState(null);
  const [dateError, setDateError] = useState("");
  const [showFutureDateWarning, setShowFutureDateWarning] = useState(false);
  // Add new state to track if we should show last 30 days data
  const [last30DaysSummary, setLast30DaysSummary] = useState(null);
  
   const navigate = useNavigate();
  console.log('dashboardData:', dashboardData);

// Function to get today's date in yyyy-mm-dd format for input max attribute
  const getTodayForInput = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // Function to check if a date is in the future
  const isFutureDate = (dateString) => {
    if (!dateString) return false;
    const inputDate = new Date(dateString);
    const today = new Date();
    today.setHours(23, 59, 59, 999); // Set to end of today
    return inputDate > today;
  };

  // Function to validate date range
  const validateDateRange = (from, to) => {
    setDateError("");
    setShowFutureDateWarning(false);
    if (!from || !to) {
      setDateError("Please select both from and to dates");
      return false;
    }

    if (new Date(from) > new Date(to)) {
      setDateError("From date cannot be later than to date");
      return false;
    }
    // Check for future date
    if (isFutureDate(from) || isFutureDate(to)) {
      setShowFutureDateWarning(true);
      return false;
    }
    return true;
  };

  // Function to get last 30 days range in dd/mm/yyyy format
  const getLast30DaysRange = () => {
    const today = new Date();
    const thirtyDaysAgo = new Date(today);
    thirtyDaysAgo.setDate(today.getDate() - 30);

    const formatDate = (date) => {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    };
    return {
      from: formatDate(thirtyDaysAgo),
      to: formatDate(today)
    };
  };
  // Function to get last 30 days range in yyyy-mm-dd format (for input values)
  const getLast30DaysRangeForInput = () => {
    const today = new Date();
    const thirtyDaysAgo = new Date(today);
    thirtyDaysAgo.setDate(today.getDate() - 30);

    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
    return {
      from: formatDate(thirtyDaysAgo),
      to: formatDate(today)
    };
  };

  // Convert yyyy-mm-dd (input format) to dd/mm/yyyy (backend format
  const convertToBackendFormat = (inputDate) => {
    if (!inputDate) return "";
    const [year, month, day] = inputDate.split('-');
    return `${day}/${month}/${year}`;
  };
  // Auto-correct future dates to today
  const handleDateChange = (field, value) => {
    let correctedValue = value;
    if (isFutureDate(value)) {
      correctedValue = getTodayForInput();
      // Show a brief message about auto-correction
      setTimeout(() => {
        setDateError(`Date corrected to today (${new Date().toLocaleDateString()})`);
        setTimeout(() => setDateError(""), 3000);
      }, 100);
    }

    setSelectedDateRange(prev => ({
      ...prev,
      [field]: correctedValue
    }));
  };

  // Function to fetch last 30 days payment data
  const fetchLast30DaysData = async () => {
    const vendorCode = localStorage.getItem("userId");
    const dateRange = getLast30DaysRange();

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/getPaymentDetailsByDate`,
        {
          from: dateRange.from,
          to: dateRange.to,
          vendorCode: vendorCode
        }
      );

      if (response.data.status) {
        // Calculate summary from filtered data
        const payments = response.data.data;
        const totalEarnings = payments.reduce((sum, payment) => {
          return sum + (parseFloat(payment.paymentAmount) || 0);
        }, 0);

        setLast30DaysSummary({
          bookings: response.data.count,
          earnings: totalEarnings,
          dateRange: dateRange
        });
        console.log("Last 30 days payment data:", response.data);

      } else {
         setLast30DaysSummary({
          bookings: 0,
          earnings: 0,
          dateRange: dateRange
        });
      }
      }
      catch (error) {
      console.error("Error fetching last 30 days payments:", error);
      // Fallback to showing 0 values if API fails
      setLast30DaysSummary({
        bookings: 0,
        earnings: 0,
        dateRange: getLast30DaysRange()
      });
    }
  };

useEffect(() => {
    // Always fetch dashboard data first
    fetchDashboardData();
    // Fetch last 30 days payment data by default
    fetchLast30DaysData();
    // Then check if there's a saved date range in sessionStorage
    const savedDateRange = sessionStorage.getItem('vendorDashboardDateRange');
    if (savedDateRange) {
      try {
        const parsedRange = JSON.parse(savedDateRange);
        setSelectedDateRange(parsedRange);
    // Apply the saved date range after a brief delay to ensure dashboard data is loaded
        setTimeout(() => {
          handleDateRangeSubmitWithDates(parsedRange.from, parsedRange.to);
        }, 500);
      } catch (error) {
        console.error('Error parsing saved date range:', error);
        sessionStorage.removeItem('vendorDashboardDateRange');
      }
    }
  }, []);

  const fetchDashboardData = () => {
    const vendorCode = localStorage.getItem("userId");
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/vendor-dashboard/${vendorCode}`)
      .then((res) => setDashboardData(res.data))
      .catch((err) => {
        console.error("Dashboard fetch error:", err);
        setDashboardData(0);
      });

    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/getVendorPaymentStatus/${vendorCode}`)
      .then((res) => {
        if (res.data.status) {
          console.log("data", res.data);
          setPaymentData(res.data.payments);
        } else {
          setPaymentData(0);
        }
      })
      .catch((err) => {
        console.error("Failed to load payment data", err);
        setPaymentData(0);
      });
  };

  const handleDateRangeSubmitWithDates = async (fromDate, toDate) => {
    if (!fromDate || !toDate) return;
    const vendorCode = localStorage.getItem("userId");
    // Convert dates to backend format (dd/mm/yyyy)
    const fromDateFormatted = convertToBackendFormat(fromDate);
    const toDateFormatted = convertToBackendFormat(toDate);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/getPaymentDetailsByDate`,
        {
          from: fromDateFormatted,
          to: toDateFormatted,
          vendorCode: vendorCode
        }
      );
      if (response.data.status) {
        // Calculate summary from filtered data
        const payments = response.data.data;
        const totalEarnings = payments.reduce((sum, payment) => {
          return sum + (parseFloat(payment.paymentAmount) || 0);
        }, 0);
        setCustomDateSummary({
          bookings: response.data.count,
          earnings: totalEarnings,
          dateRange: {
            from: fromDateFormatted,
            to: toDateFormatted
          }
        });
        console.log("Filtered payment data:", response.data);
      } else {
        setCustomDateSummary({
          bookings: 0,
          earnings: 0,
          dateRange: {
            from: fromDateFormatted,
            to: toDateFormatted
          }
        });
      }
    } catch (error) {
      console.error("Error fetching payments by date:", error);
    }
  };

  const handleDateRangeSubmit = async () => {
    if (!validateDateRange(selectedDateRange.from, selectedDateRange.to)) {
      return;
    }
    setIsLoading(true);
    // Save to sessionStorage
    sessionStorage.setItem('vendorDashboardDateRange', JSON.stringify(selectedDateRange));

    await handleDateRangeSubmitWithDates(selectedDateRange.from, selectedDateRange.to);
    setIsLoading(false);
    setShowDatePicker(false);
  };
  const resetToLast30Days = () => {
    setSelectedDateRange({ from: "", to: "" });
    setCustomDateSummary(null);
    setShowDatePicker(false);
    setDateError("");
    setShowFutureDateWarning(false);
    // Remove from sessionStorage
    sessionStorage.removeItem('vendorDashboardDateRange');
    // Fetch last 30 days data again
    fetchLast30DaysData();
  };
  // Quick date range presets
  const setQuickRange = (days) => {
    const today = new Date();
    const startDate = new Date(today);
    startDate.setDate(today.getDate() - days);
    const formatForInput = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    setSelectedDateRange({
      from: formatForInput(startDate),
      to: formatForInput(today)
    });
    setDateError("");
    setShowFutureDateWarning(false);
  };

  if (!dashboardData) {
    return <div className="text-center mt-10">Loading...</div>;
  }

  const {
    completed,
    cancelled,
    working,
    total,
    bookings,
    earnings,
    cashCollected,
    cashDeposited,
    paymentsMade,
    dateRange,
  } = dashboardData;
  
 const displaySummary = customDateSummary || last30DaysSummary || {
    bookings,
    earnings,
    dateRange: getLast30DaysRange() // Use calculated range instead of backend range
  };

  return (
    // <div className="font-satoshi w-full max-w-md mx-auto pl-4 pr-4 pb-4 pt-[6rem] bg-white min-h-screen text-gray-800">
    
      <div className="font-satoshi w-full max-w-md mx-auto px-4 pb-4 pt-[6rem] bg-white min-h-screen text-gray-800 overflow-x-hidden">

      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        {/* <button><Menu className="text-gray-700" /></button> */}
        <h1 className="text-lg font-semibold">Dashboard</h1>
                {/* <button><Bell className="text-gray-700" /></button> */}

      </div>

      {/* Active / Inactive Cards */}
      <div className="grid grid-cols-2 gap-2 mb-4">
         <div className="bg-gray-100 rounded-lg p-2 text-center ring-2 ring-blue-400 shadow-lg border-blue-400">
          <p className="text-sm text-gray-500">TOTAL CASES</p>
          <p className="text-xl font-bold text-black">{total}</p>
        </div>
        <div className="bg-gray-100 rounded-lg p-2 text-center ring-2 ring-blue-400 shadow-lg border-blue-400">
          <p className="text-sm text-gray-500">ACTIVE</p>
          <p className="text-xl font-bold text-black">{working}</p>
        </div>
        <div className="bg-gray-100 rounded-lg p-2 text-center ring-2 ring-blue-400 shadow-lg border-blue-400">
          <p className="text-sm text-gray-500">CANCELLED</p>
          <p className="text-xl font-bold text-black">{cancelled}</p>
        </div>
         <div className="bg-gray-100 rounded-lg p-2 text-center ring-2 ring-blue-400 shadow-lg border-blue-400">
          <p className="text-sm text-gray-500">COMPLETED</p>
          <p className="text-xl font-bold text-black">{completed}</p>
        </div>
      </div>

      {/* Buttons */}
      <div className="space-y-2 mb-4">
        <div onClick={() => navigate('/vendor-payment-status-tab', { state: { data: paymentData } })} className="flex items-center justify-between bg-white rounded-md shadow-sm px-4 py-3 border cursor-pointer">
          <div className="flex items-center gap-2">
            <CreditCard size={18} className="text-gray-600" />
            <span  className="text-sm font-medium">View Payment Details</span>
          </div>
          <ChevronRight size={16} className="text-gray-500" />
        </div>
        <div onClick={() => navigate('/crane-user-all-cases')} className="flex items-center justify-between bg-white rounded-md shadow-sm px-4 py-3 border cursor-pointer">
          <div className="flex items-center gap-2">
            <TrendingUp size={18} className="text-gray-600" />
            <span  className="text-sm font-medium">View All Trip Details</span>
          </div>
          <ChevronRight size={16} className="text-gray-500" />
        </div>
      </div>

      {/* Last 30 Days Summary */}
      <div className="mb-4 bg-[#bbefff] rounded-md shadow-sm p-2">
        <div className="flex items-center justify-between px-1 mb-2">
          <div className="text-sm text-gray-600">
            <p className="font-semibold">{customDateSummary ? "CUSTOM RANGE" : "LAST 30 DAYS"}</p>
            <p className="text-xs text-gray-500">
              {customDateSummary 
                ? `${customDateSummary.dateRange.from} - ${customDateSummary.dateRange.to}`
                : `${displaySummary.dateRange.from} - ${displaySummary.dateRange.to}`
              }
            </p>
          </div>
          <button 
            onClick={() => setShowDatePicker(true)}
            className="hover:bg-blue-100 p-1 rounded-full transition-colors"
          >
            <Calendar size={16} className="text-gray-500" />
          </button>
        </div>

        <div className="bg-white border rounded-md shadow-sm p-4 space-y-2">
          <div className="flex justify-between font-semibold text-sm">
            <span>Total Summary</span>
            <span>₹ {displaySummary.earnings?.toLocaleString("en-IN")}</span>
          </div>
          <hr />
          <div className="text-sm text-gray-600 space-y-1">
            <div className="flex justify-between">
              <span>Bookings</span>
              <span>{displaySummary.bookings}</span>
            </div>
            <div className="flex justify-between">
              <span>Total Earnings</span>
              <span>₹ {displaySummary.earnings?.toLocaleString("en-IN")}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Payments Made */}
      
      {/* <DashboardInformation /> */}
      {showDatePicker && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg w-full max-w-sm max-h-[90vh] overflow-y-auto">
            {/* Modal Header */}
            <div className="flex items-center justify-between p-4 border-b sticky top-0 bg-white">
              <h3 className="text-lg font-semibold">Select Date Range</h3>

              <button 
                onClick={() => setShowDatePicker(false)}
                className="hover:bg-gray-100 p-1 rounded-full"
              >
                <X size={20} className="text-gray-500" />
              </button>
            </div>

            {/* Modal Content */}
            <div className="p-4 space-y-4">
              {/* Quick Range Buttons */}
              <div className="space-y-2">
                <p className="text-sm font-medium text-gray-700">Quick Select:</p>
                <div className="grid grid-cols-3 gap-2">
                  <button
                    onClick={() => setQuickRange(7)}
                    className="px-3 py-2 text-xs border border-gray-300 rounded-md hover:bg-gray-50 transition-colors"
                  >
                    Last 7 days
                  </button>
                  
                  <button
                    onClick={() => setQuickRange(15)}
                    className="px-3 py-2 text-xs border border-gray-300 rounded-md hover:bg-gray-50 transition-colors"
                  >
                    Last 15 days
                  </button>
                  <button
                    onClick={() => setQuickRange(30)}
                    className="px-3 py-2 text-xs border border-gray-300 rounded-md hover:bg-gray-50 transition-colors"
                  >
                    Last 30 days
                  </button>
                </div>
              </div>
              <hr />
              {/* Date Inputs */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  From Date
                </label>

                <input
                  type="date"
                  max={getTodayForInput()}
                  value={selectedDateRange.from}
                  onChange={(e) => handleDateChange('from', e.target.value)}
                  className="w-full text-sm px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  To Date
                </label>

                <input
                  type="date"
                  max={getTodayForInput()}
                  value={selectedDateRange.to}
                  onChange={(e) => handleDateChange('to', e.target.value)}

                  className="w-full text-sm px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />

              </div>
              {/* Error Messages */}
              {dateError && (
                <div className="flex items-center gap-2 p-3 bg-red-50 border border-red-200 rounded-md">
                  <AlertCircle size={16} className="text-red-500 flex-shrink-0" />
                  <p className="text-sm text-red-700">{dateError}</p>
                </div>
              )}
              {/* Future Date Warning */}
              {showFutureDateWarning && (
                <div className="flex items-start gap-2 p-3 bg-yellow-50 border border-yellow-200 rounded-md">
                  <Info size={16} className="text-yellow-600 flex-shrink-0 mt-0.5" />
                  <div className="text-sm text-yellow-800">
                    <p className="font-medium">Future dates not allowed</p>
                    <p>You can only view data up to today. Future dates will show no results.</p>
                  </div>
                </div>
              )}
              {/* Action Buttons */}
              <div className="flex gap-2 pt-2">
                <button
                  onClick={resetToLast30Days}
                  className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors"
                >
                  Reset
                </button>
                
                <button
                  onClick={handleDateRangeSubmit}

                  disabled={isLoading || !selectedDateRange.from || !selectedDateRange.to || dateError || showFutureDateWarning}

                  className="flex-1 px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
                >
                  {isLoading ? "Loading..." : "Apply"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VendorDashboard;

